import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import dayjs from 'dayjs'
import BaseService from 'services/BaseService'
import { popNotification } from 'utils/popNotification'
import { notificationConfig } from './constants'
import { LIMIT } from 'constants/app.constant'
import { formatDateSend } from '../../functions/formatDateSend'

const { creation, edit, deletion } = notificationConfig

// Redux Toolkit slice
const standardsSlice = createSlice({
    name: 'standards',
    initialState: {
        data: [],
        details: [],
        isLoading: false,
        error: null,
        created: null,
        isDeleted: null,
        currentPage: 1,
    },
    reducers: {},
    extraReducers: (builder) => {
        builder
        .addCase(fetchDetailsStandards.pending, (state) => {
            state.isLoading = true
            state.error = null
        })
        .addCase(fetchDetailsStandards.fulfilled, (state, action) => {
            const currentPage = action?.meta?.arg?.page || state.currentPage;

            state.currentPage = currentPage
            state.isLoading = false
            state.details = action.payload
        })
        .addCase(fetchDetailsStandards.rejected, (state, action) => {
            state.isLoading = false
            state.error = action.error.message
        })
            .addCase(fetchStandards.pending, (state) => {
                state.isLoading = true
                state.error = null
            })
            .addCase(fetchStandards.fulfilled, (state, action) => {
                const currentPage = action?.meta?.arg?.page || state.currentPage;

                state.currentPage = currentPage
                state.isLoading = false
                state.data = action.payload
            })
            .addCase(fetchStandards.rejected, (state, action) => {
                state.isLoading = false
                state.error = action.error.message
            })
            .addCase(createStandard.pending, (state) => {
                state.isLoading = true
                state.error = null
            })
            .addCase(createStandard.fulfilled, (state, action) => {
                state.isLoading = false
                state.created = true
            })
            .addCase(createStandard.rejected, (state, action) => {
                state.isLoading = false
                state.error = action.error.message
                state.created = false
            })
            .addCase(deleteStandard.pending, (state) => {
                state.isLoading = true
                state.isDeleted = null
            })
            .addCase(deleteStandard.fulfilled, (state) => {
                state.isLoading = false
                state.isDeleted = true
            })
            .addCase(deleteStandard.rejected, (state, action) => {
                state.isLoading = false
                state.error = action.error.message
                state.isDeleted = false
            })
    },
})

// Async thunk action to fetch data from the API
export const fetchStandards = createAsyncThunk(
    'standards/fetch',
    async (payload) => {
        const page = payload?.page || 1
        const limit = payload?.limit || LIMIT
        const search = payload?.search || ''
        const statut_f = payload?.statut_f || ''
        let date_d_f = payload?.date?.[0] || ''
        let date_f_f = payload?.date?.[1] || ''
        if (dayjs(date_d_f).isValid() && dayjs(date_f_f).isValid()) {
            date_d_f = dayjs(date_d_f).format('YYYY-MM-DD');
            date_f_f = dayjs(date_f_f).format('YYYY-MM-DD');
        } else if (dayjs(date_d_f).isValid()) {
            date_d_f = dayjs(date_d_f).format('YYYY-MM-DD');
            date_f_f = date_d_f;
        } else if (dayjs(date_f_f).isValid()) {
            date_f_f = dayjs(date_f_f).format('YYYY-MM-DD');
            date_d_f = date_f_f;
        }
        try {
            const response = await BaseService.get(
                `/XML/qualite.standard.load?page=${page}&limit=${limit}&text=${search}&statut_f=${statut_f}&date_d_f=${date_d_f}&date_f_f=${date_f_f}`
            )

            return response.data
        } catch (error) {
            throw new Error('Failed to fetch standards')
        }
    }
)
// Async thunk action to fetch details from the API
export const fetchDetailsStandards = createAsyncThunk(
    'Standards/fetchDetails',
    async (id) => {
        const data = id.id
        try {
            const Standard = await BaseService.get(
                `/XML/qualite.standard.load/details?id=${data}`
            )
            

            return Standard.data
        } catch (error) {
            throw new Error('Failed to fetch Standards')
        }
    }
)
export const createStandard = createAsyncThunk(
    'standards/post',
    async (payload) => {
        const { data, formik, navigate, setClientAdded } = payload
        const { resetForm, setSubmitting } = formik
        try {
            const response = await BaseService.post('/XML/qualite.standard.send/add', data)
            if (response.status === 200) {
                resetForm()
                setSubmitting(false)
                popNotification(creation?.success)
                setClientAdded(true)
            }
        } catch (err) {
            console.log({ err })
            
            setSubmitting(false)
            
            popNotification(creation?.error)
        }
    }
)

export const editStandard = createAsyncThunk('standards/edit',
async (payload) => {
    const { data, formik, navigate, setClientAdded } = payload
    const { resetForm, setSubmitting } = formik
    try {
        const response = await BaseService.post('/XML/qualite.standard.send/edit', data)
        if (response.status === 200) {
            resetForm()
            setSubmitting(false)
            popNotification(creation?.success)
            setClientAdded(true)
        }
    } catch (err) {
        console.log({ err })
        
        popNotification(creation?.error)
    }

})

export const deleteStandard = createAsyncThunk(
    'standard/delete',
    async (payload) => {
        const { id, closeDialog } = payload
        if (!id) return
        try {
            const response = await BaseService.delete(`/standards/${id}`)
            if (response.status === 200 || response.status === 201) {
                popNotification(deletion?.success)
                closeDialog()
                return true
            }
        } catch (err) {
            console.log({ err })
            popNotification(deletion?.error)
            return
        }
    }
)

export const selectData = (state) => state.standards.data
export const selectIsLoading = (state) => state.standards.isLoading
export const selectError = (state) => state.standards.error
export const selectIsDeleted = (state) => state.standards.isDeleted
export const selectCurrentPage = (state) => state.standards.currentPage

export default standardsSlice.reducer
